import { atom } from "jotai";

export const dialogState = atom({
    show: false,
    data: {},
});
